import { React, useState } from 'react';
import '../../App.css';
import { Grid, TextField, Box, Button, Paper, Typography } from '@mui/material';
import { PeopleAlt } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function TopEmployeesReport() {
  const [financialYear, setFinancialYear] = useState('');
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    const temp = {};
    if (!financialYear) {
      temp.financialYear = 'This field is required.';
    } else if (!/^\d{4}-\d{4}$/.test(financialYear)) {
      temp.financialYear = 'Format must be YYYY-YYYY (e.g. 2024-2025)';
    } else {
      const [start, end] = financialYear.split('-').map(Number);
      if (end !== start + 1) {
        temp.financialYear = 'End year must be start year + 1 (e.g. 2024-2025)';
      }
    }
    setErrors(temp);
    return Object.values(temp).every((x) => x === '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/report/top-employees-by-salary`,
        { financial_year: financialYear }
      );
      navigate('/top-employees-report-generated', {
        state: { reportData: response.data, financialYear },
      });
    } catch (error) {
      const status = error?.response?.status;
      const msg =
        error?.response?.data?.error_message ||
        'Failed to fetch top employees report. Please try again.';
      setNotify({ isOpen: true, message: msg, type: 'error' });
      if (status === 401) {
        setTimeout(() => navigate('/'), 1000);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '10px',
        padding: '50px',
        fontWeight: '500px',
      }}
    >
      <Paper elevation={5} sx={{ width: '1000px', height: '210px' }}>
        <Grid
          className="form-title"
          container
          spacing={2}
          justifyContent="center"
          style={{ marginTop: '15px' }}
          alignItems="center"
        >
          <Grid item>
            <PeopleAlt sx={{ fontSize: 42, color: '#0b418e' }} />
          </Grid>
          <Grid item>
            <Typography variant="h5">Top Employees by Salary Report</Typography>
          </Grid>
        </Grid>

        <form autoComplete="off" onSubmit={handleSubmit}>
          <Box sx={{ margin: '30px' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: 2,
                flexWrap: 'wrap',
              }}
            >
              <TextField
                variant="outlined"
                label={<RequiredLabel label="Financial Year" />}
                name="financialYear"
                value={financialYear}
                placeholder="e.g. 2024-2025"
                onChange={(e) => {
                  setFinancialYear(e.target.value);
                  if (errors.financialYear) setErrors({ ...errors, financialYear: '' });
                }}
                sx={{ width: '220px' }}
                InputLabelProps={{ shrink: true }}
                size="small"
                error={!!errors.financialYear}
                helperText={errors.financialYear}
              />

              <Button
                className="form-btn"
                color="success"
                variant="contained"
                type="submit"
                disabled={loading}
                sx={{ height: 40 }}
              >
                {loading ? 'Loading...' : 'Display'}
              </Button>
            </Box>
          </Box>
        </form>
      </Paper>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default TopEmployeesReport;
